import { Icon, Image, ListCell, ListView } from '@modulor/react';
import clx from 'classnames';
import React from 'react';

import SkeletonNetwork from '../../components/Skeleton/init/SkeletonNetwork';
import styles from './CurrencySelect.module.scss';

export interface SelectValue {
  id: string | number;
  title: string;
  icon?: string;
}

interface CurrencySelectProps {
  selectedCurrency: SelectValue | null;
  fullWidth: boolean;
  label: string;
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  hideRigthIcon?: boolean;
  dataTestId?: string;
}

const RightIcon = ({ visible }: { visible: boolean }) => {
  if (!visible) return null;

  return (
    <span>
      <Icon name="chevron_up_chevron_down" />
    </span>
  );
};

const CurrencySelect = ({
  selectedCurrency,
  fullWidth,
  label,
  onClick,
  isLoading,
  hideRigthIcon,
  disabled,
  dataTestId,
}: CurrencySelectProps) => (
  <div
    data-testid={dataTestId}
    onClick={onClick}
    className={clx(
      'select-currency-container',
      styles.cursorPointer,
      fullWidth ? styles.fullWidth : styles.halfWidth,
      disabled && styles.disabled,
    )}
  >
    {isLoading ? (
      <SkeletonNetwork />
    ) : (
      <ListView className={styles.selectCurrencyCardBox}>
        <ListCell
          className="list-cell-control"
          text={selectedCurrency?.title || ''}
          subtitle={label}
          rightImage={<RightIcon visible={!hideRigthIcon} />}
          icon={
            selectedCurrency?.icon ? (
              <Image src={selectedCurrency.icon} alt={selectedCurrency.title} decoding="async" loading="lazy" />
            ) : undefined
          }
          inverted
        />
      </ListView>
    )}
  </div>
);

export default CurrencySelect;
